import React from "react";
import "./FollowUpPrint.scss";
import moment from "moment";
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader";

export default function FollowUpPrint({
  prescriptionPlansPrint,
  testsRequestedPrint,
  takeHomeMedicinePrint,
  chemotherapyPrint,
  componentRef,
  origin,
  patientDetail,
  smartSummaryData,
  appointmentDate
}: any) {

  return (
    <div className="prescriptions-print-wrapper"
      ref={componentRef}>
      {/* Patient Details */}
      <PatientDetailsPrintHeader
        patientData={{ patientInfo: patientDetail, vitalsData: null }}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDate}
      />
      {/* Prescription Pad */}
      {origin == "followUp" && (
        (
          (prescriptionPlansPrint?.some((outer: any) => {
            return outer?.medicines?.some((inner: any) => inner?.medicineName);
          }))
        ) && (
          < section className="chemo-order">
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="prescriptions-primary-heading">
                  Prescription Pad
                </div>
                {prescriptionPlansPrint?.filter((e: any) => e?.addToPrint)?.length >
                  0
                  ? prescriptionPlansPrint
                    ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                    ?.map((each: any) => {
                      return (
                        <>
                          <div className="prescriptions-secondary-heading">
                            Prescription ID: {each?.prescriptionId}
                          </div>
                          <table className="pre-medication-table-container">
                            <thead>
                              <th>Sr.No</th>
                              <th>Type</th>
                              <th>Medicine</th>
                              <th>Dose</th>
                              <th>When</th>
                              <th>Frequency</th>
                              <th>Duration</th>
                              <th>Notes/Instructions</th>
                              <th>Side Effects</th>
                            </thead>
                            <tbody>
                              {each?.medicines?.map((e: any, index: any) => (
                                <tr className="procedure-data">
                                  <td>{index + 1}</td>
                                  <td>{e?.type}</td>
                                  <td>{e?.medicineName}</td>
                                  <td>{e?.dose}</td>
                                  <td>{e?.when}</td>
                                  <td>{e?.frequency}</td>
                                  <td>{e?.duration}</td>
                                  <td>{e?.instructions}</td>
                                  <td>
                                    <ul>
                                      {e?.selectedSideEffects?.map(
                                        (sideEffect: any) => {
                                          return <li>{sideEffect}</li>
                                        }
                                      )}
                                    </ul>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      )
                    })
                  : "NA"}
              </div>
            </div>
          </section>
        )
      )
      }
      {/* Premedication && Chemotherapy Administration */}
      {
        origin !== "followUp" && (

          <>
            {
              (
                (prescriptionPlansPrint?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }))
              ) && (
                <section className="chemo-order">
                  <div className="chemo-order-details">
                    <div className="pre-medication-container">
                      <div className="prescriptions-primary-heading">
                        Premedication
                      </div>
                      {prescriptionPlansPrint?.filter((e: any) => e?.addToPrint)?.length >
                        0
                        ? prescriptionPlansPrint
                          ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                          ?.map((each: any) => {
                            return (
                              <>
                                {/* <div className="prescriptions-secondary-heading">
                              PreMedication 
                            </div> */}
                                <table className="pre-medication-table-container">
                                  <thead>
                                    <th>Sr.No</th>
                                    <th>Type</th>
                                    <th>Medicine</th>
                                    <th>Dose</th>
                                    <th>When</th>
                                    <th>Route</th>
                                    <th>Notes/Instructions</th>
                                    <th>Duration</th>
                                    <th>Side Effects</th>
                                  </thead>
                                  <tbody>
                                    {each?.medicines?.map((e: any, index: any) => (
                                      <tr className="procedure-data">
                                        <td>{index + 1}</td>
                                        <td>{e?.type}</td>
                                        <td>{e?.medicineName}</td>
                                        <td>{e?.dose}</td>
                                        <td>{e?.when}</td>
                                        <td>{e?.route}</td>
                                        <td>{e?.duration}</td>
                                        <td>{e?.instructions}</td>
                                        <td>
                                          <ul>
                                            {e?.selectedSideEffects?.map(
                                              (sideEffect: any) => {
                                                return <li>{sideEffect}</li>
                                              }
                                            )}
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </>
                            )
                          })
                        : "NA"}
                    </div>
                  </div>
                </section>
              )
            }
            {
              (
                (chemotherapyPrint?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }))
              ) && (
                <section className="chemo-order">
                  <div className="chemo-order-details">
                    <div className="pre-medication-container">
                      <div className="prescriptions-primary-heading">
                        Chemotherapy  Administration
                      </div>
                      {chemotherapyPrint?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                        ?.length > 0
                        ? chemotherapyPrint
                          ?.filter((e: any) => e?.addToPrint)
                          ?.map((each: any) => {
                            return (
                              <>
                                {/* <div className="prescriptions-secondary-heading">
                          Prescription ID: {each?.prescriptionId}
                        </div> */}
                                <table className="pre-medication-table-container">
                                  <thead>
                                    <th>Sr.no</th>
                                    <th>Type</th>
                                    <th>Medicine</th>
                                    <th>Standard Dose</th>
                                    <th>Dose</th>
                                    <th>Dose Modification</th>
                                    <th>Route</th>
                                    <th>Notes/Instructions</th>
                                    <th>Side Effects</th>
                                  </thead>
                                  <tbody>
                                    {each?.medicines?.map((item: any, j: any) => (
                                      <tr className="procedure-data">
                                        <td>{j + 1}</td>
                                        <td>{item?.type}</td>
                                        <td>{item?.medicineName}</td>
                                        <td>{item?.standardDose}</td>
                                        <td>{item?.dose}</td>
                                        <td>{item?.doseModification}</td>
                                        <td>{item?.route}</td>
                                        <td>{item?.instructions}</td>
                                        <td>
                                          <ul>
                                            {item?.selectedSideEffects?.map(
                                              (sideEffect: any) => {
                                                return <li>{sideEffect}</li>
                                              }
                                            )}
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </>
                            )
                          })
                        : "NA"}
                    </div>
                  </div>
                </section>
              )
            }
          </>
        )
      }
      {/* Take Home Medicines */}
      {
        origin !== "followUp" && (
          (
            (takeHomeMedicinePrint?.some((outer: any) => {
              return outer?.medicines?.some((inner: any) => inner?.medicineName);
            }))
          ) && (
            <section className="chemo-order">
              <div className="chemo-order-details">
                <div className="pre-medication-container">
                  <div className="prescriptions-primary-heading">
                    Take Home Medicine
                  </div>
                  {takeHomeMedicinePrint?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                    ?.length > 0
                    ? takeHomeMedicinePrint
                      ?.filter((e: any) => e?.addToPrint)
                      ?.map((each: any) => {
                        return (
                          <>
                            <div className="prescriptions-secondary-heading">
                              Prescription ID: {each?.prescriptionId}
                            </div>
                            <table className="pre-medication-table-container">
                              <thead>
                                <th>Sr.no</th>
                                <th>Type</th>
                                <th>Medicine</th>
                                <th>Dose</th>
                                <th>When</th>
                                <th>Frequency</th>
                                <th>Duration</th>
                                <th>Notes/Instructions</th>
                                <th>Side Effects</th>
                              </thead>
                              <tbody>
                                {each?.medicines?.map((item: any, j: any) => (
                                  <tr className="procedure-data">
                                    <td>{j + 1}</td>
                                    <td>{item?.type}</td>
                                    <td>{item?.medicineName}</td>
                                    <td>{item?.dose}</td>
                                    <td>{item?.when}</td>
                                    <td>{item?.frequency}</td>
                                    <td>{item?.duration}</td>
                                    <td>{item?.instructions}</td>
                                    <td>
                                      <ul>
                                        {item?.selectedSideEffects?.map(
                                          (sideEffect: any) => {
                                            return <li>{sideEffect}</li>
                                          }
                                        )}
                                      </ul>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )
                      })
                    : "NA"}
                </div>
              </div>
            </section>
          )
        )
      }
      {/* Tests Required */}
      {
        (
          testsRequestedPrint?.some((outer: any) => {
            return outer?.tests?.some((inner: any) => inner?.testName);
          })
        ) && (
          <section className="chemo-order">
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="prescriptions-primary-heading">Tests Required</div>
                {
                  testsRequestedPrint?.filter((e: any) => e?.addToPrint)?.length > 0
                    ? testsRequestedPrint
                      ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                      ?.map((eachTest: any) => {
                        return (
                          <>
                            {/* <div className="prescriptions-secondary-heading">
                              Integration Order ID: {eachTest?.integrationOrderId}
                            </div> */}
                            {
                              eachTest?.tests?.every((eTest: any) => eTest?.serviceId || eTest?.instructions || eTest?.when) ?
                                <table className="pre-medication-table-container">
                                  <thead>
                                    <th>Sr.No</th>
                                    <th>Test</th>
                                    <th>Instructions</th>
                                    <th>When</th>
                                  </thead>
                                  <tbody>
                                    {
                                      eachTest?.tests?.length > 0 ? (
                                        eachTest?.tests?.map((e: any, index: any) => (
                                          <tr className="procedure-data">
                                            {/* {JSON.stringify(values)} */}
                                            <td>{index + 1}</td>
                                            <td>
                                              {e?.testName}
                                            </td>
                                            <td>{e?.instructions}</td>
                                            <td>{e?.when && moment(e?.when).format(
                                              "DD-MM-YYYY")}</td>
                                          </tr>
                                        ))
                                      ) : <p>NA</p>
                                    }
                                  </tbody>
                                </table>
                                :
                                <p>NA</p>
                            }
                          </>
                        )
                      })
                    : <p>NA</p>}
              </div>
            </div>
          </section>
        )
      }
    </div >
  )
}